

export const AreEngineFeatures = {
    Load: '_AreEngine_Load',
    Build: '_AreEngine_Build',
    Execute: '_AreEngine_Execute',
}